import { Autocomplete, Box, TextField } from "@mui/material";
import { useQuery } from "@apollo/client";
import { GET_BANDS } from "./graphql";
import { without } from "ramda";
import { Band } from "../../__generated__/graphql";
import { useMemo } from "react";

interface IBandPickerProps {
  handleChange: (bandId: string, option?: Band | null) => void;
  defaultValue?: string;
  value: string | undefined;
  placeholder?: string;
  controlStyle?: React.CSSProperties;
  except?: string[];
}

export const BandPicker = ({
  handleChange,
  defaultValue,
  value,
  placeholder,
  controlStyle,
  except,
}: IBandPickerProps) => {
  const { data, loading } = useQuery(GET_BANDS);

  const filtered = without([value], except ?? []);

  const availableBands = useMemo(() => {
    const bands = data?.bands ?? [];
    const seen = new Set<string>();

    return bands.filter((band) => {
      if (!band?.id) return false;
      if (seen.has(band.id)) return false;
      seen.add(band.id);
      return true;
    });
  }, [data?.bands]);

  const selectedBand =
    availableBands.find((band) => band.id === (value ?? defaultValue)) ?? null;

  const options =
    availableBands.filter((band) => !filtered?.includes(band.id)) ?? [];

  return (
    <Box
      style={{
        width: "100%",
        marginTop: "20px",
        marginBottom: "20px",
        ...controlStyle,
      }}
    >
      <Autocomplete
        fullWidth
        // @ts-ignore
        value={selectedBand}
        options={options}
        disableClearable
        loading={loading}
        getOptionLabel={(option) => option?.name ?? ""}
        isOptionEqualToValue={(option, val) => option.id === val.id}
        onChange={(_, newValue) => {
          // @ts-ignore
          handleChange(newValue?.id ?? "", newValue ?? null);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Band"
            placeholder={placeholder ?? "Select a band"}
            InputLabelProps={{ shrink: true }}
          />
        )}
      />
    </Box>
  );
};
